module.exports = __webpack_public_path__ + "pc/media/PC_about_time_lapse.0acef316.mp4";